import Add from "@material-ui/icons/Add";
import * as FileSaver from "file-saver";
import React from "react";
import Fade from "react-reveal/Fade";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import KioskForm from "../../components/Kiosk/KioskForm/KioskForm";
import ViewKiosk from "../../components/Kiosk/ViewKiosk/ViewKiosk";
import Button from "../../components/UI/Button/Button";
import Input from "../../components/UI/Input/Input";
import Modal from "../../components/UI/Modal/Modal";
import Search from "../../components/UI/Search/Search";
import Spinner from "../../components/UI/Spinner/Spinner";
import Table from "../../components/UI/Table/Table";
import FetchData from "../../shared/fetchData";
import { updateObject } from "../../shared/utility";
import { Collapse } from "@material-ui/core";
import ShowBoxes from "../../components/UI/ShowBoxes/ShowBoxes";

const Kiosks = (props) => {
  const [loading, setLoading] = React.useState(false);
  const [rerender, setRerender] = React.useState(false);
  const [pageSize, setPageSize] = React.useState(10);
  const [pageIndex, setPageIndex] = React.useState(0);
  const [pageCount, setPageCount] = React.useState(0);
  const [tableData, setTableData] = React.useState([]);
  const [permission, setPermission] = React.useState(
    window.localStorage.getItem("permission")
  );
  const [kiosks, setKiosks] = React.useState([]);
  const [newKioskPage, setNewKioskPage] = React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [view, setView] = React.useState(false);
  const [changeForm, setChangeForm] = React.useState(false);
  const [showBoxes, setShowBoxes] = React.useState(false);
  const [kiosk, setKiosk] = React.useState("");
  const [kioskId, setKioskId] = React.useState("");
  const [kioskTypes, setKioskTypes] = React.useState([]);
  const [zones, setZones] = React.useState([]);
  const [lockers, setLockers] = React.useState([]);
  const [shifts, setShifts] = React.useState([]);
  const [kioskShifts, setKioskShifts] = React.useState([]);
  const [lockerId, setLockerId] = React.useState([]);
  const [searchParams, setSearchParams] = React.useState({
    description: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "نام",
      },
      validation: {
        required: true,
      },
      errorMessage: "",
      valid: true,
      value: "",
    },
  });

  const childRef = React.useRef();
  const finalizeChildRef = React.useRef();
  const monitoringStateRef = React.useRef();

  React.useEffect(() => {
    setLoading(true);
    setPageIndex(0);
    setPageSize(10);
    setPageCount(0);
    var raw = JSON.stringify({
      kioskType: {
        finalized: "1",
      },
      pl: "10000",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/kiosktypes/getKioskTypes";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          setKioskTypes(result.kioskTypes);
        }
      })
      .catch((error) => setLoading(false));

    var raw = JSON.stringify({
      zone: {},
      pl: "1000",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/zones/getZones";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          setZones(result.zones);
        }
      })
      .catch((error) => setLoading(false));
    var raw = JSON.stringify({
      shift: {},
      pl: "10000",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/shifts/getShifts";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          setShifts(result.shifts);
        }
      })
      .catch((error) => setLoading(false));
  }, []);

  const exportToCSV = (event) => {
    const token = window.localStorage.getItem("token");
    var raw = JSON.stringify({
      kiosk: {
        description: searchParams.description.value,
      },
      pl: "1048576",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/kiosks/getKiosks";
    setLoading(true);
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          let exportOrderReport = [];
          let count = 0;
          const orderReport = result.kiosks.map((o) => {
            count++;
            exportOrderReport.push({
              ردیف: count,
              شناسه: o.id,
              نام: o.description,
              "نوع لاکر": o.kioskType != null ? o.kioskType.description : "",
              zone: o.zone != null ? o.zone.description : "",
              وضعیت:
                o.isActive != null && o.isActive == "1"
                  ? "فعال است"
                  : "فعال نیست",
              "وضعیت لاکر":
                o.finalized != null && o.finalized == "1"
                  ? "نهایی شده"
                  : "نهایی نشده",
              آدرس: o.address,
              "کد پستی": o.postalCode,
            });
          });
          const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          const fileExtension = ".xlsx";
          const ws = XLSX.utils.json_to_sheet(exportOrderReport);
          const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
          const excelBuffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array",
          });
          const data = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(data, "data" + fileExtension);
        }
      })
      .catch((error) => setLoading(false));
  };

  const inputChangedHandler = (event, controlName) => {
    const updatedControls = updateObject(searchParams, {
      [controlName]: updateObject(searchParams[controlName], {
        value: event.target.value,
      }),
    });
    setSearchParams(updatedControls);
  };

  const getData = (pagination, isRefresh) => {
    setPageIndex(pagination.pageIndex);
    setPageSize(pagination.pageSize);
    setLoading(true);
    var raw =
      !!isRefresh && isRefresh
        ? JSON.stringify({
            pl: pagination.pageSize,
            pn: pagination.pageIndex + 1,
            version: "mtpx001",
          })
        : JSON.stringify({
            kiosk: {
              description: searchParams.description.value,
            },
            pl: pagination.pageSize,
            pn: pagination.pageIndex + 1,
            version: "mtpx001",
          });
    var url = "management/api/v1/kiosks/getKiosks";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          let newList = [];
          for (let i = 0; i < pagination.pageIndex * pagination.pageSize; i++) {
            newList.push([]);
          }
          newList = newList.concat(result.kiosks);
          pushData(newList);
          setKiosks(newList);
          setPageCount(result.count);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => setLoading(false));
  };
  const pushData = (data) => {
    const rows = [];
    const headers = [
      {
        accessorKey: "identifier",
        header: "شناسه",
        align: "center",
      },
      {
        accessorKey: "description",
        header: "نام",
        align: "center",
      },
      {
        accessorKey: "kioskType",
        header: "نوع لاکر",
        align: "center",
      },
      {
        accessorKey: "zone",
        header: "zone",
        align: "center",
      },
      {
        accessorKey: "isActive",
        header: "وضعیت",
        align: "center",
      },
      {
        accessorKey: "finalized",
        header: "وضعیت لاکر",
        align: "center",
      },
      {
        accessorKey: "disableMonitor",
        header: "وضعیت مانیتورینگ",
        align: "center",
      },
      {
        accessorKey: "city",
        header: "شهر",
        align: "center",
      },
      {
        accessorKey: "address",
        header: "آدرس",
        align: "center",
      },
      {
        accessorKey: "postalCode",
        header: "کد پستی",
        align: "center",
      },
    ];
    const buttons = [];
    setTableData({ rows: rows, headers: headers, buttons: buttons });
    data.map((d) => {
      rows.push({
        id: d.id,
        identifier: d.id,
        description: d.description,
        kioskType: d.kioskType != null ? d.kioskType.description : "",
        zone: d.zone != null ? d.zone.description : "",
        isActive:
          d.isActive != null && d.isActive == "1" ? "فعال است" : "فعال نیست",
        finalized:
          d.finalized != null && d.finalized == "1"
            ? "نهایی شده"
            : "نهایی نشده",
        disableMonitor:
          d.disableMonitor != null && d.disableMonitor == "1"
            ? "فعال است"
            : "فعال نیست",
        address: d.address,
        city: d.city?.description,
        postalCode: d.postalCode,
      });
    });
    buttons.push({ id: 1, text: "ویرایش", clicked: editKiosk });
    buttons.push({ id: 2, text: "مشاهده", clicked: viewKiosk });
    buttons.push({ id: 3, text: "تغییر وضعیت", clicked: kioskChangeState });
    buttons.push({ id: 4, text: "نهایی سازی", clicked: kioskFinalize });
    if (permission != null && permission.includes("KIOSK_WRITE")) {
      buttons.push({ id: 5, text: "باکس ها", clicked: showLockers });
    }
    buttons.push({
      id: 4,
      text: "تغییر وضعیت مانیتورینگ",
      clicked: changeKioskMonitorState,
    });
    setTableData({ rows: rows, headers: headers, buttons: buttons });
    setRerender(!rerender);
  };
  const search = (event) => {
    getData({ pageIndex: pageIndex, pageSize: pageSize });
  };

  const refresh = (event) => {
    const srch = searchParams;
    for (let key in srch) {
      srch[key].value = "";
    }
    setSearchParams(srch);
    getData({ pageIndex: pageIndex, pageSize: pageSize }, true);
  };

  const toggleNewLockerForm = (event, value) => {
    if (value == false) {
      search();
    }
    setNewKioskPage(value);
  };

  const addNewKiosk = (event, id) => {
    setKiosk("");
    setEdit(false);
    toggleNewLockerForm(event, true);
  };

  const editKiosk = (id, data) => {
    var raw = JSON.stringify({
      kioskShift: {
        kiosk: {
          id: id,
        },
      },
      pl: "10000",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/kioskshifts/getKioskShifts";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          const kskShifts = [];
          result.kioskShifts.map((k) => {
            kskShifts.push(k.shift.id);
          });
          setKioskShifts(kskShifts);
          const lckrTp = data.filter((l) => l.id == id);
          if (lckrTp != null && lckrTp.length != 0) {
            setKiosk(lckrTp[0]);
            setEdit(true);
            toggleNewLockerForm(null, true);
          }
        }
      })
      .catch((error) => setLoading(false));
  };

  const viewKiosk = (id, data) => {
    var raw = JSON.stringify({
      kioskShift: {
        kiosk: {
          id: id,
        },
      },
      pl: "10000",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/kioskshifts/getKioskShifts";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          const kskShifts = [];
          result.kioskShifts.map((k) => {
            kskShifts.push(k.shift.id);
          });
          setKioskShifts(kskShifts);
          const lckrTp = data.filter((l) => l.id == id);
          if (lckrTp != null && lckrTp.length != 0) {
            setKiosk(lckrTp[0]);
            setView(true);
          }
        }
      })
      .catch((error) => setLoading(false));
  };

  const addShift = (event, shiftId) => {
    if (kioskShifts.includes(shiftId)) {
      const shfts = kioskShifts;
      for (var key = 0; key < shfts.length; key++) {
        if (shfts[key] == shiftId) {
          shfts.splice(key, 1);
        }
      }
      setKioskShifts(shfts);
    } else {
      const shfts = kioskShifts;
      shfts.push(shiftId);
      setKioskShifts(shfts);
    }
    if (changeForm) {
      setChangeForm(false);
    } else {
      setChangeForm(true);
    }
  };
  const formElementsArray = [];
  for (let key in searchParams) {
    formElementsArray.push({
      id: key,
      config: searchParams[key],
    });
  }

  const toggleViewKioskForm = (event, value) => {
    setView(value);
  };

  const kioskChangeState = (id, data) => {
    setKioskId(id);
    childRef.current.openModal();
  };

  const kioskFinalize = (id, data) => {
    const item = data.filter((d) => d.id === id);
    if (!!item && item.length > 0) {
      if (item[0].finalized != null && item[0].finalized == "1") {
        toast.error("رکورد مورد نظر نهایی است");
      } else {
        setKioskId(id);
        finalizeChildRef.current.openModal();
      }
    }
  };
  const changeKioskMonitorState = (id, data) => {
    setKioskId(id);
    monitoringStateRef.current.openModal();
  };
  const closeModal = (event, id) => {
    childRef.current.closeModal();
  };
  const closeFinalizeModal = (event, id) => {
    finalizeChildRef.current.closeModal();
  };
  const kioskChangeStateSubmit = (event) => {
    var raw = JSON.stringify({
      kiosk: {
        id: kioskId,
      },
      pl: "10000",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/kiosks/changeKioskState";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          childRef.current.closeModal();
          search();
        }
      })
      .catch((error) => setLoading(false));
  };
  const changeKioskMonitorStateSubmited = (event) => {
    var raw = JSON.stringify({
      kiosk: {
        id: kioskId,
      },
      pl: "10000",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/kiosks/changeKioskMonitorState";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          monitoringStateRef.current.closeModal();
          search();
        }
      })
      .catch((error) => setLoading(false));
  };
  const kioskFinalizeSubmit = (event) => {
    var raw = JSON.stringify({
      kiosk: {
        id: kioskId,
      },
      pl: "10000",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/kiosks/finalizeKiosk";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          finalizeChildRef.current.closeModal();
          search();
        }
      })
      .catch((error) => setLoading(false));
  };

  const afterCloseModal = (event) => {};

  const showLockers = (id) => {
    setKioskId(id);
    console.log(id);
    var raw = JSON.stringify({
      locker: {
        kiosk: {
          id: id,
        },
      },
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    });
    var url = "management/api/v1/lockers/getLockers";
    setLoading(true);
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          setLockers(result.lockers);
          setShowBoxes(true);
        }
      })
      .catch((error) => setLoading(false));
  };

  let form = formElementsArray.map((formElement) => {
    return (
      <Input
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        placeholder={formElement.config.placeholder}
        errorMessage={formElement.config.errorMessage}
        search={true}
        col="3 mt-2"
        changed={(event) => inputChangedHandler(event, formElement.id)}
      />
    );
  });
  form = (
    <div>
      <div className="row pl-4" dir="ltr" style={{ height: "0px" }}>
        <Button btnType="Refresh" clicked={refresh}></Button>
      </div>
      <div className="row mt-4">{form}</div>
      <div className="row text-left" dir="ltr">
        <div className="col-2">
          <Button btnType="search-btn" clicked={search}>
            جستجو
          </Button>
        </div>
        <div className="col-2 text-left ord-small-btns">
          <Button btnType="Search" clicked={exportToCSV}>
            <span className="tab-color">گزارشگیری</span>
          </Button>
        </div>
      </div>
    </div>
  );

  const modalContent = (
    <div>
      <div className="row justify-content-center">
        آیا از تغییر وضعیت مطمئن هستید؟
      </div>
      <div className="row justify-content-center mt-3">
        <div className="col-6">
          <Button btnType="Success" clicked={kioskChangeStateSubmit}>
            بله
          </Button>
        </div>
        <div className="col-6">
          <Button btnType="Success" clicked={closeModal}>
            خیر
          </Button>
        </div>
      </div>
    </div>
  );
  const finalizeModalContent = (
    <div>
      <div className="row justify-content-center">
        آیا از نهایی کردن مطمئن هستید؟
      </div>
      <div className="row justify-content-center mt-3">
        <div className="col-6">
          <Button btnType="Success" clicked={kioskFinalizeSubmit}>
            بله
          </Button>
        </div>
        <div className="col-6">
          <Button btnType="Success" clicked={closeFinalizeModal}>
            خیر
          </Button>
        </div>
      </div>
    </div>
  );
  const monitoringState = (
    <div>
      <div className="row justify-content-center">
        آيا از تغيير وضعيت مانیتورینگ مطمئن هستيد؟
      </div>
      <div className="row justify-content-center mt-5">
        <div className="col-6">
          <Button btnType="Success" clicked={changeKioskMonitorStateSubmited}>
            بله
          </Button>
        </div>
        <div className="col-6">
          <Button
            btnType="General"
            clicked={() => monitoringStateRef.current.closeModal()}
          >
            خير
          </Button>
        </div>
      </div>
    </div>
  );
  return (
    <div>
      {loading ? <Spinner /> : ""}
      <Collapse in={!showBoxes}>
        {!newKioskPage && !view ? (
          <Fade duration={200} left cascade>
            <div>
              <Search class="orders-search" form={form} />
              {permission != null && permission.includes("KIOSK_WRITE") ? (
                <div className="row justify-content-center mt-3 ml-3">
                  <div className="UserGeneralBtn">
                    <div
                      onClick={(event) => addNewKiosk(event)}
                      className="Add"
                    >
                      <Add className="UserIcon" />
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              {rerender ? (
                // <Spinner />
                <Table
                  hasDetails={false}
                  data={kiosks}
                  pageSize={pageSize}
                  pageIndex={pageIndex}
                  getData={getData}
                  list={tableData}
                  rowCount={pageCount}
                  columnSize={170}
                  loading={loading}
                />
              ) : (
                <Table
                  hasDetails={false}
                  data={kiosks}
                  pageSize={pageSize}
                  pageIndex={pageIndex}
                  getData={getData}
                  list={tableData}
                  rowCount={pageCount}
                  columnSize={170}
                  loading={loading}
                />
              )}
            </div>
          </Fade>
        ) : (
          <div>
            {!view ? (
              <KioskForm
                shifts={shifts}
                addShift={addShift}
                kioskShifts={kioskShifts}
                kioskTypes={kioskTypes}
                zones={zones}
                edit={edit}
                kiosk={edit ? kiosk : ""}
                toggleNewLockerForm={toggleNewLockerForm}
              />
            ) : (
              <ViewKiosk
                shifts={shifts}
                back={toggleViewKioskForm}
                kioskTypes={kioskTypes}
                kioskShifts={kioskShifts}
                zones={zones}
                kiosk={kiosk}
              />
            )}
          </div>
        )}
      </Collapse>
      <Collapse in={showBoxes}>
        <ShowBoxes
          checkIsActive={true}
          boxes={lockers}
          kioskId={kioskId}
          showLockers={(value) => showLockers(value)}
        />
        <div className="row justify-content-center w-100 ml-0 mr-0 mt-3">
          <Button btnType="Success" clicked={() => setShowBoxes(false)}>
            برگشت
          </Button>
        </div>
      </Collapse>
      <Modal
        content={modalContent}
        ref={childRef}
        closePermission="true"
        closeModal={(event) => afterCloseModal(event)}
      />
      <Modal
        content={finalizeModalContent}
        ref={finalizeChildRef}
        closePermission="true"
        closeModal={(event) => afterCloseModal(event)}
      />
      <Modal
        content={monitoringState}
        ref={monitoringStateRef}
        closePermission="true"
        closeModal={(event) => afterCloseModal(event)}
      />
    </div>
  );
};

export default Kiosks;
